<template>
    <div class="is-large">
        <div class="lb-community-post">
            <div class="lb-card-content">
                <div>
                    <div class="level is-mobile">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <span class="is-size-6 has-text-weight-bold">
                                    {{ content.created | timeFormatPost }}
                                </span>
                            </div>
                        </div>
                        <div v-if="content.owner" class="level-right">
                            <div class="level-item">
                                <p
                                    :data-tooltip="content.owner.name"
                                    class="image is-24x24 has-tooltip-bottom"
                                >
                                    <img
                                        :src="content.owner.avatar"
                                        loading="lazy"
                                        class="is-rounded lb-avatar"
                                        referrerpolicy="no-referrer"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p v-t="'Constants.POST_ACTIVITY_TITLE'" />
                </div>

                <div v-if="content.activity" class="pt-3">
                    <section
                        :class="{
                            'has-background-very-light-pink-two':
                                !content.activity.image,
                        }"
                        class="hero is-medium has-background"
                    >
                        <img
                            v-if="content.activity.image"
                            :src="content.activity.image.url"
                            alt
                            class="hero-background"
                        />
                        <div class="hero-body"></div>
                    </section>
                    <div
                        class="
                            lb-project-modal-content
                            has-text-centered has-background-white-ter
                        "
                    >
                        <p
                            class="
                                title
                                is-size-6
                                has-text-grey has-text-weight-bold
                                is-uppercase
                                mb-0
                                pt-4
                            "
                        >
                            <span class="category">
                                {{ content.activity.area }}
                            </span>
                        </p>
                        <p
                            class="
                                title
                                is-size-5
                                has-text-weight-bold has-text-black
                                pt-4
                                mb-4
                            "
                        >
                            {{ content.activity.title }}
                        </p>
                        <div
                            class="is-size-6 has-text-black mb-4"
                            v-html="content.activity.shortDescription"
                        ></div>

                        <router-link
                            v-t="'Buttons.go_to_activity'"
                            :to="{
                                name: 'activity',
                                params: { activityId: content.activity._id },
                                query: ga_query,
                            }"
                            tag="a"
                            class="
                                button
                                is-primary is-uppercase
                                px-5
                                mb-6
                                mt-4
                            "
                        ></router-link>
                    </div>
                </div>

                <div class="level is-mobile py-4 is-marginless" @click.stop>
                    <div
                        :class="{ 'has-cursor-pointer': isLoggedIn }"
                        class="level-left"
                    >
                        <div
                            :class="{ 'has-text-primary': content.liked }"
                            class="level-item"
                            @click="toggleLike"
                        >
                            <p class="has-text-weight-bold">
                                {{ content.likes || 0 }}
                            </p>
                            <span class="icon is-medium">
                                <i
                                    class="mdi mdi-18px mdi-thumb-up"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <div
                                class="
                                    dropdown
                                    is-right is-hoverable is-pulled-right
                                "
                            >
                                <span
                                    class="
                                        icon
                                        is-small
                                        dropdown-trigger
                                        has-text-grey
                                    "
                                >
                                    <i
                                        class="mdi mdi-24px mdi-dots-vertical"
                                        aria-hidden="true"
                                    />
                                </span>
                                <div class="dropdown-menu" role="menu">
                                    <div class="dropdown-content">
                                        <a
                                            v-if="isOwner || isCommunityAdmin"
                                            v-t="'Options.delete'"
                                            class="dropdown-item"
                                            @click="deletePost"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <object-card-comments
                    v-if="isMember && isValidated"
                    :creationDisabled="true"
                    :editionDisabled="true"
                    :comments="content.comments"
                    :object="content"
                    :model-related="'community'"
                    :render-all="showAllComments"
                    @loadOldComments="showAllComments = true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ObjectCardComments from '@/components/ObjectCardComments';
import _ from 'underscore';
import { likePost } from '@/services/API';
import moment from 'moment';
export default {
    components: {
        ObjectCardComments,
    },
    filters: {
        timeFormat(timestamp) {
            return moment(timestamp).format('DD/MM/YY HH:mm');
        },
        timeFormatPost(timestamp) {
            return moment(timestamp).format('DD/MM/YY');
        },
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            startReadingTime: null,
            observer: null,
            isIntersecting: false,
            showToolbar: false,
            showAllComments: false,
            showShareModal: false,
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        isMember() {
            return this.$store.getters.community.accessLevel !== 'read';
        },
        isCommunityAdmin() {
            return this.$store.getters.community.accessLevel == 'administrator';
        },
        isOwner() {
            return this.content.owner.owner === this.$store.getters.user.owner;
        },
        participants() {
            return _.map(
                this.$store.getters.community.participants,
                (participant) => {
                    return participant.owner;
                }
            );
        },
        isValidated() {
            return this.content.status == 'PUBLISHED';
        },
        ga_query() {
            if (this.$store.getters.community.title) {
                return {
                    utm_source: this.$store.getters.community.title.replace(
                        ' ',
                        '+'
                    ),
                    utm_medium: 'feed',
                    utm_campaign: 'internal_navigation',
                };
            } else {
                return {};
            }
        },
    },
    watch: {
        isIntersecting(newValue, oldValue) {
            if (this.content._id == 'draft') {
                return;
            }
            if (this.isIntersecting) {
                this.startReadingTime = new Date();
                this.$ga.event({
                    eventCategory: 'Post',
                    eventAction: 'view',
                    eventLabel: this.content._id,
                });
            }
            if (newValue == false && oldValue == true) {
                this.$ga.event({
                    eventCategory: 'Post',
                    eventAction: 'reading_time',
                    eventLabel: this.content._id,
                    value: new Date() - this.startReadingTime,
                });
                this.startReadingTime = null;
            }
        },
    },
    created() {
        this.observer = new IntersectionObserver(this.onElementObserved, {
            root: this.$el,
            threshold: 1.0,
        });
    },
    beforeDestroy() {
        this.observer = null;
    },
    mounted() {
        this.observer.observe(this.$el);
    },

    methods: {
        onElementObserved(entries) {
            entries.forEach(({ target, isIntersecting }) => {
                this.isIntersecting = isIntersecting;
            });
        },
        deletePost() {
            if (confirm(this.$t('delete_post_confirmation_message'))) {
                this.$store
                    .dispatch('deletePost', {
                        post: this.content,
                        community: this.$store.getters.community._id,
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        return;
                    });
            }
        },
        async toggleLike() {
            if (this.isLoggedIn) {
                let likeResult = await likePost(this.content._id);
                this.content.liked = likeResult.data.liked;
                this.content.likes = likeResult.data.likes;
            }
        },
    },
};
</script>

<style scoped lang="sass">
.toolbar
    position: absolute
    top: -20px
    right: 10px

.hero
    &.has-background
        position: relative
        overflow: hidden
    &-background
        position: absolute
        object-fit: cover
        object-position: center center
        width: 100%
        height: 100%
        &.is-transparent
            opacity: 0.3
</style>
<style scoped>
.hero-body {
    z-index: 1;
}
.lb-community-partner-image {
    bottom: 1rem;
    left: 1rem;
    max-width: 200px;
}
.hero.has-background .close {
    z-index: 2;
    position: absolute;
    text-shadow: 2px 3px 2px rgb(0 0 0 / 50%);
}
.category {
    display: inline-block;
    padding-top: 0.3rem;
    vertical-align: top;
}
</style>
